import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Subscription } from "rxjs";

import { Config } from "src/app/config";
import { UserAuthService } from "src/app/services/userauth.service";
import { ModalDialogService } from "src/app/modals/modaldialog/modaldialog.service";
import { SERVERRESPONSERESULT } from "src/app/models/serverresponse";

@Component({
  templateUrl: "./pageviewlogin.component.html",
})
export class PageViewLoginComponent implements OnInit, OnDestroy {
  form: FormGroup;
  routerParams: Subscription;
  userExamId: number;
  adminMessage: string = Config.ADMIN_FROM_BACKOFFICE;

  constructor(
    private userAuthService: UserAuthService,
    private router: Router,
    fb: FormBuilder,
    private modalDialogService: ModalDialogService,
    private activatedRoute: ActivatedRoute,
  ) {
    this.form = fb.group({
      email: ["", [Validators.required]],
      password: ["", [Validators.required, Validators.minLength(6)]],
    });
    this.userExamId = 0;
  }

  ngOnInit() {
    this.routerParams = this.activatedRoute.params.subscribe(params => {
      this.userExamId = +params["id"]; // (+) converts string 'id' to a number
    });
  }

  ngOnDestroy() {
    this.routerParams.unsubscribe();
  }

  onSubmit(): void {
    this.userAuthService.login(this.form.value.email, this.form.value.password).subscribe(
      response => {
        if (response.result == SERVERRESPONSERESULT.OK) {
          this.router.navigate(["view", this.userExamId]);
        } else if (response.result == SERVERRESPONSERESULT.Error) {
          this.modalDialogService.showAlert(Config.APP_NAME, response.error);
        }
      },
      error => {
        console.error(error);
      },
    );
  }
}
